var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackwardArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.350296 6.89519C0.244958 6.78972 0.185791 6.64675 0.185791 6.49769C0.185791 6.34863 0.244958 6.20566 0.350296 6.10019L5.9753 0.475187C6.02679 0.419922 6.08889 0.375596 6.15789 0.344852C6.22689 0.314108 6.30138 0.297577 6.3769 0.296244C6.45243 0.294912 6.52745 0.308805 6.59749 0.337096C6.66753 0.365387 6.73116 0.407495 6.78457 0.46091C6.83799 0.514323 6.8801 0.577949 6.90839 0.64799C6.93668 0.718031 6.95057 0.793052 6.94924 0.86858C6.94791 0.944107 6.93137 1.01859 6.90063 1.08759C6.86989 1.15659 6.82556 1.21869 6.77029 1.27019L2.1053 5.93519L14.2478 5.93519C14.397 5.93519 14.5401 5.99445 14.6455 6.09994C14.751 6.20543 14.8103 6.3485 14.8103 6.49769C14.8103 6.64687 14.751 6.78995 14.6455 6.89543C14.5401 7.00092 14.397 7.06019 14.2478 7.06019L2.1053 7.06019L6.77029 11.7252C6.82556 11.7767 6.86989 11.8388 6.90063 11.9078C6.93137 11.9768 6.94791 12.0513 6.94924 12.1268C6.95057 12.2023 6.93668 12.2773 6.90839 12.3474C6.8801 12.4174 6.83799 12.4811 6.78457 12.5345C6.73116 12.5879 6.66753 12.63 6.59749 12.6583C6.52745 12.6866 6.45243 12.7005 6.3769 12.6991C6.30138 12.6978 6.22689 12.6813 6.15789 12.6505C6.08889 12.6198 6.02679 12.5755 5.9753 12.5202L0.350296 6.89519Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardArrow);
export default __webpack_public_path__ + "static/media/backwardArrow.c9dddcdd0ec3ca31525ab0129c9531b2.svg";
export { ForwardRef as ReactComponent };